export default {
    alexa: {
        tcl_assitant: "Enable Skill - TCL Assistant",
        active_code_hint: "Bitte den Bestätigungscode eingeben",
        active_code_placeholder: "Bestätigungscode",

        active_code_message: "Wenn der TCL-TV eingeschaltet ist, drücken Sie die Einstellungettaste",
        active_code_message_path: " auf Ihrer Fernbedienung.Gehen Sie zu 'System'  > 'Funktioniert mit Alexa',",
        active_code_message_part2: "und wählen Sie 'Anmelden' oder 'Code erhalten' um den Aktivierungs-Code zu bekommen.",

        active_code_message_old: "Auf dem TCL TV, gehen Sie zu ",
        active_code_message_path_old: "Einstellungen/System/Amazon Alexa/Code erhalten, ",
        active_code_message_part2_old: "Geben Sie dann den Aktivierungscode ein.",

        active_code_error_null: "Der Code darf nicht null sein",
        active_code_error_number: "Bitte geben Sie Zahlen ein",
        active_code_error_bits: "Der Code sollte aus sechs Ziffern bestehen",
        active_code_validate: "Bestätigen",
        active_code_message_wrong: "Der Aktivierungscode ist falsch oder abgelaufen, bitte erneut erwerben.",
        active_code_message_exception: "Bitte überprüfen Sie Ihr Netzwerk und versuchen Sie es erneut.",
        check_agreements_message: "Sie müssen allen Vereinbarungen zur Verwendung des TCL-Assistenten zustimmen",
        agreements: [
            "Ich stimme TCL zu, um meinen Sprachbefehl aufzuzeichnen",
            "Ich stimme TCL zu ",
            "."
        ],
        privacy_policy: "Datenschutz-Bestimmungen",

        grant_hint: "TCL möchte in Ihrem Namen Aktionen durchführen",
        grant_message_success: "Sie haben erfolgreich gewährt",
        grant_message_fail: "Zuschuss fehlgeschlagen, bitte geben Sie den aktiven Code erneut ein",
        grant_allow: "ermöglichen",

        console_welcome_prompt: "Willkommen bei TCL Alexa Konsole",
        empty_message: "",
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/locale/lang/de.js
// module id = null
// module chunks = 